import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogContent,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import {
  MultiSelectorAutocomplete,
  FormDialogActions,
  FormDialogTitle,
  FormCancelButton,
  FormSubmitButton,
} from '@marageti/z4-lib';
import { Destination } from '@marageti/z4-sdk/lib/travel';

export type TravelerProfileBucketListModalProps = {
  destinationsList: Destination[];
  initialDestinations: Destination[];
  isLoading: boolean;
  onClose: () => void;
  onSubmit: (codes: string[]) => void;
  open: boolean;
};

const TravelerProfileBucketListModal = ({
  destinationsList,
  initialDestinations,
  isLoading,
  onClose,
  onSubmit,
  open,
}: TravelerProfileBucketListModalProps) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('desktop'));
  const [selectedDestinations, setSelectedDestinations] = useState<Destination[]>(initialDestinations);

  useEffect(() => {
    if (open) {
      setSelectedDestinations(initialDestinations);
    }
  }, [open, initialDestinations]);

  const handleSubmit = () => {
    onSubmit(selectedDestinations.map((dest) => dest.id));
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      fullScreen={fullScreen}
    >
      <FormDialogTitle handleClose={onClose} sx={{ pb: 0.5 }}>
        Bucket List Destinations
      </FormDialogTitle>
      <DialogContent>
        <Typography variant="body" color="primary" sx={{ mb: 2 }}>
          These preferences improve trip matching.
        </Typography>
        <MultiSelectorAutocomplete
          isLoading={isLoading}
          label="Destinations"
          labelFieldName="name"
          name="destinations"
          onChange={(_: any, data: any[]) => {
            setSelectedDestinations(data);
          }}
          optionEntities={destinationsList}
          value={selectedDestinations}
          valueFieldName="id"
        />
      </DialogContent>
      <FormDialogActions>
        <FormCancelButton onClick={onClose} />
        <FormSubmitButton onClick={handleSubmit}>
          Save Destinations
        </FormSubmitButton>
      </FormDialogActions>
    </Dialog>
  );
};

export default TravelerProfileBucketListModal;
